define('modules/accounts/groups/index',['require','exports','module','./model'],function(require, exports, module) {
    "use strict";

    var Model = require("./model");
    
    module.exports = {
        Model: Model        
    };

});
